import { Box, BoxProps, GridItem, Td } from "@chakra-ui/react";

interface TableCellProps extends BoxProps {
  selected?: boolean;
}

export function TableCell({ children, selected = false, ...rest }: TableCellProps) {
  return (
    <GridItem
      as={Td}
      display="flex"
      alignItems="center"
      overflow="hidden"
      textOverflow="ellipsis"
      whiteSpace="nowrap"
      verticalAlign="middle"
      color="brand.deep_sea"
      fontWeight={400}
      textStyle="sm"
      p={2}
      py={3}
      borderBottomWidth={0}
      {...rest}
      _first={{ pl: 0 }}
      _last={{ pr: 0 }}
      {...(rest.onClick ? { cursor: "pointer", _hover: { textDecor: "underline" } } : {})}
    >
      {typeof children === "string" || typeof children === "number" ? (
        <Box title={children + ""} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
          {children}
        </Box>
      ) : (
        children
      )}
    </GridItem>
  );
}
